import * as React from 'react';

import { getTranslation, keys } from '../../../../Resources/Translations';

interface ViagraFormGenderSelectProps {
    isMan?: boolean;
    selectMan: () => void;
    selectWoman: () => void;
}

export const ViagraFormGenderSelect = ({ isMan, selectMan, selectWoman }: ViagraFormGenderSelectProps) => {
    return (
        <div className="ViagraForm__GenderSelect">
            <div>
                <span className="ViagraForm__GenderSelectValidation">{getTranslation(keys['viagraForm.validation'])}</span>
            </div>
            <div className="ViagraForm__GenderSelectInputs">
                <span>{getTranslation(keys['viagraForm.gender'])}:</span>
                <label>
                    <input type="radio" name="gender" onChange={selectMan} checked={isMan === true} />
                    <span>{getTranslation(keys['viagraForm.man'])}</span>
                </label>
                <label>
                    <input type="radio" name="gender" onChange={selectWoman} checked={isMan === false} />
                    <span>{getTranslation(keys['viagraForm.woman'])}</span>
                </label>
            </div>
        </div>
    );
};
